import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { CommunityIcon } from 'app/components/shared/icons';

import { IDataTypeData } from '../../../PublicationContent';
import './styled';
import {
  DataTypeCommunityIconContainer,
  DataTypeCommunityPillText,
  DataTypeCommunityPillWrapper,
} from './styled';

export const dataTypeCommunityContentModifier = (
  node: HTMLDivElement,
  push: (location: any, state?: any) => void,
  setDataTypeData: React.Dispatch<React.SetStateAction<IDataTypeData>>
) => {
  node
    .querySelectorAll('[data-type="communities"], [data-type="community"]')
    .forEach((community) => {
      const slug = community.getAttribute('data-slug');
      const name = community.textContent;
      const template = document.createElement('div');
      template.innerHTML = ReactDOMServer.renderToString(
        <DataTypeCommunityPill name={name || ''} />
      );

      template.firstChild.addEventListener('click', () => {
        setDataTypeData({
          slug,
          type: 'communities',
        });
        push(`/community/${slug}`);
      });

      community.replaceWith(template.firstChild);
    });
};

interface DataTypeCommunityPillProps {
  name: string;
}

export const DataTypeCommunityPill = ({ name }: DataTypeCommunityPillProps) => {
  return (
    <DataTypeCommunityPillWrapper>
      <DataTypeCommunityIconContainer>
        <CommunityIcon width={16} height={16} fill={'var(--color-data-community-foreground)'} />
      </DataTypeCommunityIconContainer>
      <DataTypeCommunityPillText>{name}</DataTypeCommunityPillText>
    </DataTypeCommunityPillWrapper>
  );
};
